// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbedReport.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataRefreshSetting Component
 */
!(function() {
  var React = require('react');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Select = require('share/components/controls/multiSelectBox/Izenda.Select');
  var Input = require('share/components/controls/Izenda.Input');
  var observer = require('mobx-react').observer;
  var EmbedReportStore = require('logic/Izenda.EmbedReportStore');
  var localizer = require('share/localization/Izenda.Localizer');
  var ReportPartSelectionPopup = require('share/components/controls/ReportPartSelectionPopup/Izenda.ReportPartSelectionPopup');
  var ReportPartSelectionConstants = require('logic/data/Izenda.ReportPartSelectionConstants');
  var Icon = require('share/components/controls/Izenda.Icon');
  var { isNil, map } = require('lodash/fp');

  var EmbedReport = React.createClass({
    componentWillMount: function() {
      this.store = this.props.store || new EmbedReportStore();
    },

    getValue: function() {
      var model = this.store.model;
      return {
        selectedReport: model.selectedReport
      };
    },

    /**
     * Get selected report
     * @param {Object} report Report Definition
     */
    setSelectedReport: function(result) {
      var report = result.report;
      this.store.model.setSelectedReport(report);
    },

    /**
     * Get report parts
     * @param {Object} props
     * @param {String} report id
     */
    setSelectedReportPart: function(id) {
      this.store.model.selectedReport.setSelectedReportPart(id);
    },

    /**
     * Get selected report parts
     * @param {Object} props
     * @param {String} selected report parts
     * @returns {Array} id list
     */
    getSelectedReportParts: function() {
      return map(function(rp) {
        return rp.id;
      }, this.store.model.selectedReport.selectedReportParts);
    },

    // Open report selection popup
    openSearchReportPopup: function() {
      var props = this.props;

      props.openPopup(ReportPartSelectionPopup, {
        onChange: this.setSelectedReport,
        type: ReportPartSelectionConstants.TYPE.REPORT,
        excludeIds: isNil(props.reportId) ? [] : [props.reportId]
      });
    },

    render: function() {
      var store = this.store;
      var selectedReport = store.model.selectedReport;

      return (
        <GridLayout>
          <GridLayout.Row>
            <GridLayout.Col cols="3">{localizer.getText('COMMON_LABEL_REPORTS')}</GridLayout.Col>
            <GridLayout.Col cols="8">
              <Input value={selectedReport.name} className="form-control" disabled />
            </GridLayout.Col>
            <GridLayout.Col cols="1">
              <Icon className="icon-search" onClick={this.openSearchReportPopup} />
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols="3">{localizer.getText('REPORTDESIGNER_LABEL_REPORT_PART_USED')}</GridLayout.Col>
            <GridLayout.Col cols="8">
              <Select
                simpleValue
                multi
                options={selectedReport.reportParts}
                labelKey="title"
                valueKey="id"
                onChange={this.setSelectedReportPart}
                value={this.getSelectedReportParts()}
                scalable={false}
              />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      );
    }
  });

  module.exports = observer(EmbedReport);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.EmbedReport.jsx